module.exports = __webpack_public_path__ + "img/logo_h5.52f131f1.png";